import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ChatV2 = _resolveComponent("ChatV2")
  const _component_ChatV1 = _resolveComponent("ChatV1")

  return ($props.chat.type === 'chat_v2')
    ? (_openBlock(), _createBlock(_component_ChatV2, {
        key: 0,
        chat: $props.chat
      }, null, 8 /* PROPS */, ["chat"]))
    : (_openBlock(), _createBlock(_component_ChatV1, {
        key: 1,
        chat: $props.chat
      }, null, 8 /* PROPS */, ["chat"]))
}